import { getPricingApiConfig, getProductPrices } from '@gn-audio/jss-core';

import { mapToStandardPriceModel } from 'api/pricesApi/priceMapper';
import { StandardPriceModel } from 'api/pricesApi/pricesModel';
import { logServerError } from 'utils/logger';

export const getSfccProductPrices = async (skus: string[]): Promise<StandardPriceModel[]> => {
  const noPrices = new Array(skus.length).fill(null);
  try {
    const { isSFCCPricingOn } = getPricingApiConfig();
    if (!isSFCCPricingOn) {
      return noPrices;
    }
    const prices = await getProductPrices(skus);

    return prices ? prices.map(mapToStandardPriceModel) : noPrices;
  } catch (error) {
    logServerError(error);
    // null prevents infinite skeleton loader animation
    return noPrices;
  }
};
